import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";

import * as log from "loglevel";

import store from "REDUX/store";

//import CreateSessionContainer from "COMPONENTS/Sessions/SessionsContainer";
import LoginContainer from "COMPONENTS/Login/LoginContainer";
import LogoutContainer from "COMPONENTS/Logout/LogoutContainer";
import DashboardContainer from "COMPONENTS/Dashboard/DashboardContainer";
import MainLayoutContainer from "COMPONENTS/MainLayout/MainLayoutContainer";
import SessionManagementMainlayout from "COMPONENTS/SessionManagement/SessionManagementMainlayout";
import UserJoinContainer from "COMPONENTS/UserJoin/UserJoinContainer";
import UserEvictedContainer from "../Components/UserEvicted/UserEvictedContainer";
import TestPage from "COMPONENTS/TestPage/TestPage";
import ReJoinContainer from "COMPONENTS/ReJoin/ReJoinContainer";
import SetPasswordContainer from "COMPONENTS/SetPassword/SetPasswordContainer";
import ResetPasswordContainer from "COMPONENTS/ResetPassword/ResetPasswordContainer";
import QRCodeContainer from "COMPONENTS/QRCode/QRCodeComponent/QRCodeContainer";
import QrExpired from "COMPONENTS/QRCode/UIComponents/StaticScreen/QrExpired";
import SessionEndScreenContainer from "COMPONENTS/SessionEndScreen/SessionEndScreenContainer";
import SSOLogin from "COMPONENTS/Login/SSOLogin";
import SSOLogout from "COMPONENTS/Login/SSOLogout";
import SSOAuthenticated from "COMPONENTS/SSOAuthenticated/SSOAuthenticated"
import StartSupportCenterSessionContainer from "COMPONENTS/SupportCenter/StartSupportCenterSession/StartSupportCenterSessionContainer";
import ServerUnreachableContainer from "COMPONENTS/ServerUnreachable/ServerUnreachableContainer";

import OrganisationsContainer from "COMPONENTS/SuperAdmin/Organisations/OrganisationsContainer";
import AdminDashboardContainer from "COMPONENTS/SuperAdmin/Users/AdminDashboardContainer";
import WaitingScreen from "COMPONENTS/WaitingScreen/WaitingScreen";
import PageNotFound from "COMPONENTS/ErrorComponents/PageNotFound";
import UserWaitingRoom from "COMPONENTS/UserWaiting/UserWaitingContainer";
import AddOrganizationContainer from "COMPONENTS/SuperAdmin/AddOrganization/AddOrganizationContainer";
import EditOrganizationContainer from "COMPONENTS/SuperAdmin/EditOrganization/EditOrganizationContainer";
import AdminSettngsContainer from "COMPONENTS/SuperAdmin/SettingsPage/SettingsPageContainer";
import SupportCenterContainer from 'COMPONENTS/SuperAdmin/SupportCenter/SupportCenterContainer';
import { WebRTCMessage } from "COMPONENTS/CommonComponents/WebRTCMessage/WebRTCMessage";

import { CONFIG } from "UTILS/Constants";

import { selectUserToken, selectSessionKey, getUserRole } from "./selectors";
import withErrorHandler from "../Components/withErrorHandler/withErrorHandler";
import { changeLanguage } from "CONFIG/i18n";
import { URI_IDENTIFIER_MODIFICATION_NOT_ALLOWED_PATH, USER_ROLES } from "../Utils/Constants";

import { removeTrailingSlash, getUrlPathExcludingSearchString, getStringArrayInLowerCase } from "UTILS/Utility";
import { getUrlSearchString } from "../Utils/Utility";

const PrivateRoute = ({ ...rest }) => (
  <Route
    render={(props) => {
      switch (rest.role) {
        case USER_ROLES.AGENT:
          return rest.isAuthenticated &&
            rest.path.toLowerCase() !== CONFIG.path.admin &&
            rest.path.toLowerCase() !== CONFIG.path.superAdmin ? (
              <RouteWithBaseName {...props} { ...rest }/>
            ) : (
              <Redirect
                push
                to={{
                  pathname: CONFIG.path.login,
                }}
              />
            );
          break;
        case USER_ROLES.SUPER_ADMIN:
          if (
            rest.isAuthenticated &&(
              rest.path === CONFIG.path.superAdmin ||
            rest.path === CONFIG.path.addOrganization ||
            rest.path === CONFIG.path.editOrganization
            )
          ) {
            return <RouteWithBaseName {...props} { ...rest }/>;
          } else {
            return (
              <Redirect
                push
                to={{
                  pathname: CONFIG.path.superAdminLogin,
                }}
              />
            );
          }

        case USER_ROLES.ADMIN:
          if (
            rest.isAuthenticated &&
            rest.path.toLowerCase() === CONFIG.path.admin ||
            [CONFIG.path.adminSettings, CONFIG.path.supportCenter, CONFIG.path.supportCenterReport].includes(rest.path)
          ) {
            return <RouteWithBaseName {...props} { ...rest }/>;
          } else {
            return (
              <Redirect
                push
                to={{
                  pathname: CONFIG.path.adminLogin,
                }}
              />
            );
          }
          break;
        case USER_ROLES.USER:
          return rest.path.toLowerCase() !== CONFIG.path.admin &&
            rest.path.toLowerCase() !== CONFIG.path.superAdmin &&
            rest.path.toLowerCase() !== CONFIG.path.createSession.toLowerCase() ? (
              <RouteWithBaseName {...props} { ...rest }/>
            ) : (
              <Redirect
                push
                to={{
                  pathname: CONFIG.path.login,
                }}
              />
            );
          break;
        default:
          return (
            <Redirect
              push
              to={{
                pathname: CONFIG.path.login,
              }}
            />
          );
          break;
      }
    }}
  />
);

// if uriIdentifier is set and we are trying to remove it from url, it will redirect to the url by again adding the uri path
const RouteWithBaseName = ({ component: ComponentToRender, ...rest }) => {
  let checkPathContainsValidUri = () => {
    return !rest.uriIdentifier        // uri identifier is not set
    || rest.uriIdentifier === "/"     // uri identifier is /
    || (removeTrailingSlash(window.location.pathname).split("/")[1]
     && "/"+removeTrailingSlash(window.location.pathname).split("/")[1].toLowerCase() === 
     rest.uriIdentifier.toLowerCase())  // uri identifier is already there in  url
  }

  return <Route 
    render={(props) => {
      console.log("Routing:  rest.uriIdentifier-  "+ rest.uriIdentifier+" rest.path- "+ rest.path+ "  rest.location- "+ rest.location.pathname);

      // if path has # we should redirect to a page without #
      if(rest.location.hash && rest.location.hash.startsWith("#")) {
        let searchString = getUrlSearchString(rest.location.hash);
        let redirectToPath = getUrlPathExcludingSearchString(rest.location.hash.replace('#', ''));
        
        // here we have 3 scenarios 
        // 1. /#/path: uri_dentifier not set by user
        // 2. /uri_identifer/#/path: uri is not part of hash path so we have to add it 
        // 3. /#/uri_identifer/path: here uri is a part of hash path so no need to add 
        if(rest.uriIdentifier !== '/'
        && !redirectToPath.toLowerCase().startsWith(rest.uriIdentifier.toLowerCase())) {
          window.location.replace(window.location.origin
            +rest.uriIdentifier
            +removeTrailingSlash(rest.location.pathname)
            +removeTrailingSlash(redirectToPath)
            +searchString);
        } else {
          window.location.replace(window.location.origin
            +removeTrailingSlash(rest.location.pathname)
            +removeTrailingSlash(redirectToPath)
            +searchString);
        }
        return;
      }

      // TODO: check conditions for QR code pages

      // load component if any one of the following conditions is met else redirect to path with uri_identifer
      // 1. check if uri_identifier (if present) is valid 
      // 2. no need to redirect to uri path for superadmin page 
      // 3. once user is in the session (which is determined by his role before login/join it is empty string) 
      // he should not be able to change uri 
      // for USER: on some paths like join user should not be able to change uri_identifier (if present)
      return checkPathContainsValidUri()
      || (rest.path === CONFIG.path.superAdminLogin && rest.uriIdentifier === "/")
      || (rest.path === CONFIG.path.adminLogin && rest.uriIdentifier === "/")
      || (!Object.values(USER_ROLES).includes(rest.role)
        && !URI_IDENTIFIER_MODIFICATION_NOT_ALLOWED_PATH.includes(rest.path))
        ? <ComponentToRender {...props} />
        : <Redirect
          replace
          to={{
            pathname: rest.path,
            search: rest.location && rest.location.search
          }}
        />
    }}
  />
}

log.setLevel("info");
class Routes extends Component {
  constructor(props) {
    super(props);
    changeLanguage();
  }

  componentDidMount() {
    console.log('Routes.js componentDidMount');
    document.addEventListener("dragstart", function (e) {
      if (e.target.nodeName.toUpperCase() == "IMG") {
        e.preventDefault();
        return false;
      }
    });

    document.addEventListener("contextmenu", (e) => {
      if (e.target.nodeName.toUpperCase() == "IMG") {
        e.preventDefault();
      }
    });
  }

  renderRoutes = () => {
    var uriIdentifierCaseInsensitive = new RegExp(this.props.uriIdentifier, 'gi');

    const { userToken, sessionKey } = this.props;
    return (
      <div>
        <Route 
          component={WebRTCMessage}
        />
        <Switch>
          <RouteWithBaseName
            exact
            path={CONFIG.path.login}
            component={LoginContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.adminLogin}
            component={LoginContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.sessionEnded}
            component={WaitingScreen}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.superAdminLogin}
            component={LoginContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.logout}
            component={LogoutContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.userJoin}
            component={UserJoinContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.userEvicted}
            component={UserEvictedContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.reJoin}
            component={ReJoinContainer}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.serverUnreachable}
            component={ServerUnreachableContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName 
            exact 
            path="/testPage" 
            component={TestPage} 
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.forgotPassword}
            component={ResetPasswordContainer}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.setPassword}
            component={SetPasswordContainer}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.qrExpired}
            component={QrExpired}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.sessionEndScreen}
            component={SessionEndScreenContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <Route
            exact 
            path={CONFIG.path.ssoLogin} 
            component={SSOLogin} 
            uriIdentifier={this.props.uriIdentifier}
          />
          <Route
            exact 
            path={CONFIG.path.ssoLogout} 
            component={SSOLogout} 
            uriIdentifier={this.props.uriIdentifier}
          />
          {/* Routing for completion of authentication =====> */}
          <Route
            exact 
            path={CONFIG.path.ssoAuthenticated} 
            component={SSOAuthenticated} 
            uriIdentifier={this.props.uriIdentifier}
          />
          {/* <===== Routing for completion of authentication */}
          <PrivateRoute
            exact
            path={CONFIG.path.createSession}
            component={SessionManagementMainlayout}
            isAuthenticated={userToken}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.startMeeting}
            component={SessionManagementMainlayout}
            isAuthenticated={userToken || sessionKey}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.scheduleMeeting}
            component={SessionManagementMainlayout}
            isAuthenticated={userToken || sessionKey}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.trailHistory}
            component={SessionManagementMainlayout}
            isAuthenticated={userToken || sessionKey}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.waitingUsers}
            component={SessionManagementMainlayout}
            isAuthenticated={userToken || sessionKey}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <RouteWithBaseName
            exact
            path={CONFIG.path.joinWithPasscode}
            component={UserJoinContainer}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          
          <PrivateRoute
            exact
            path={CONFIG.path.superAdmin}
            component={OrganisationsContainer}
            isAuthenticated={userToken}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.addOrganization}
            component={AddOrganizationContainer}
            isAuthenticated={userToken}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.editOrganization}
            component={EditOrganizationContainer}
            isAuthenticated={userToken}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.admin}
            component={AdminDashboardContainer}
            isAuthenticated={userToken}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.supportCenter}
            component={AdminDashboardContainer}
            isAuthenticated={userToken}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          
          <PrivateRoute
            exact
            role={this.props.role}
            isAuthenticated={userToken || sessionKey}
            path={CONFIG.path.adminSettings}
            component={AdminSettngsContainer}
            uriIdentifier={this.props.uriIdentifier}
          />
          <PrivateRoute
            exact
            path={CONFIG.path.supportCenterReport}
            component={AdminDashboardContainer}
            isAuthenticated={userToken}
            role={this.props.role}
            uriIdentifier={this.props.uriIdentifier}
          />
          {!getStringArrayInLowerCase(CONFIG.path).includes(getUrlPathExcludingSearchString(
            this.props.uriIdentifier !== '/'
              ? window.location.pathname.replace(uriIdentifierCaseInsensitive, '')
              : window.location.pathname).toLowerCase())
            ? <Route
              exact
              path={"*"} 
              component={PageNotFound}
              uriIdentifier={this.props.uriIdentifier}
            />
            : null}
          <MainLayoutContainer store={store}>
            <Switch>
              <RouteWithBaseName
                exact
                path={CONFIG.path.startSession}
                component={QRCodeContainer}
                role={this.props.role}
                uriIdentifier={this.props.uriIdentifier}
              />
              <RouteWithBaseName
                exact
                path={CONFIG.path.waitingRoom}
                component={UserWaitingRoom}
                uriIdentifier={this.props.uriIdentifier}
                role={this.props.role}
              />
              <RouteWithBaseName
                exact
                path={CONFIG.path.startSupportCenterSession}
                component={StartSupportCenterSessionContainer}
                role={this.props.role}
                uriIdentifier={this.props.uriIdentifier}
              />
              <PrivateRoute
                exact 
                path={CONFIG.path.callWaiting}
                component={SessionManagementMainlayout}
                isAuthenticated={userToken}
                role={this.props.role}
                uriIdentifier={this.props.uriIdentifier}
              />
              <PrivateRoute
                exact
                path={CONFIG.path.dashboard}
                component={DashboardContainer}
                isAuthenticated={userToken || sessionKey}
                role={this.props.role}
                uriIdentifier={this.props.uriIdentifier}
              />
            </Switch>
          </MainLayoutContainer>
        </Switch>
      </div>
    )
  }
  
  render() {
    return (
      this.renderRoutes()
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: selectUserToken(state),
    sessionKey: selectSessionKey(state),
    role: getUserRole(state),
    language: state.LanguageReducer.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withErrorHandler(
  connect(mapStateToProps, mapDispatchToProps)(Routes)
);
